// Audio utility functions

export const detectBPM = async (_audioBuffer: AudioBuffer): Promise<number> => {
  // Placeholder for BPM detection algorithm
  // In production, use a library like 'web-audio-beat-detector'
  return 120;
};

export const detectKey = async (_audioBuffer: AudioBuffer): Promise<string> => {
  // Placeholder for key detection algorithm
  // In production, use ML-based key detection
  return 'Cm';
};

export const generateWaveformData = (
  audioBuffer: AudioBuffer,
  samples: number = 1000
): number[] => {
  const rawData = audioBuffer.getChannelData(0);
  const blockSize = Math.floor(rawData.length / samples);
  const waveformData: number[] = [];

  for (let i = 0; i < samples; i++) {
    const blockStart = blockSize * i;
    let sum = 0;
    
    for (let j = 0; j < blockSize; j++) {
      sum += Math.abs(rawData[blockStart + j]);
    }
    
    waveformData.push(sum / blockSize);
  }

  return waveformData;
};

export const normalizeWaveform = (data: number[]): number[] => {
  const max = Math.max(...data);
  if (max === 0) return data;
  return data.map(val => val / max);
};

export const getDurationFromFile = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.preload = 'metadata';

    audio.onloadedmetadata = () => {
      resolve(audio.duration);
    };

    audio.onerror = () => {
      reject(new Error('Failed to load audio metadata'));
    };

    audio.src = URL.createObjectURL(file);
  });
};

// Deprecated: Use validateAudioFile from @utils/validation instead
export const validateAudioFile = (file: File): boolean => {
  const { validateAudioFile: validate } = require('./validation');
  const result = validate(file);
  return result.valid;
};




